
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('path',{attrs:{"d":"M58.153 14.571a4.286 4.286 0 00-3.947-.492l-.112.047L45 18.14V15a6.429 6.429 0 00-6.429-6.429H6.43A6.429 6.429 0 000 15v30a6.429 6.429 0 006.429 6.429H38.57A6.429 6.429 0 0045 45v-3.141l9.206 4.062A4.285 4.285 0 0060 41.906V18.094a4.285 4.285 0 00-1.847-3.523z","fill":"#FE9500"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h60v60H0z"}})])])])
          )
        }
      }
    